import DashboardIncidentsMainBranchContent from './DashboardIncidentsMainBranchContent';

export default DashboardIncidentsMainBranchContent;
